import { render, staticRenderFns } from "./StudentPanel.vue?vue&type=template&id=604a0366&scoped=true&lang=pug&"
import script from "./StudentPanel.vue?vue&type=script&lang=ts&"
export * from "./StudentPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StudentPanel.vue?vue&type=style&index=0&id=604a0366&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a0366",
  null
  
)

export default component.exports